import type { RouteObject } from 'react-router';
import { ModuleRoute } from '@/components/guards';

/** Agenda e agendamento online (parte da loja online). */
export const agendaRoutes: RouteObject[] = [
  {
    path: 'agenda',
    element: <ModuleRoute module="storefront" permission="bookings:read" />,
    children: [{ index: true, lazy: async () => ({ Component: (await import('./agenda')).AgendaPage }) }],
  },
];
